import { render, staticRenderFns } from "./resultCard.vue?vue&type=template&id=a28199e6&scoped=true&"
import script from "./resultCard.vue?vue&type=script&lang=js&"
export * from "./resultCard.vue?vue&type=script&lang=js&"
import style0 from "./resultCard.vue?vue&type=style&index=0&id=a28199e6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28199e6",
  null
  
)

export default component.exports